import { ProductAttributeType, ProductGroupType } from '@@partner:types:app'
import React from 'react'

import { SelectPicker } from 'rsuite'


const productGroupTypes: { value: ProductAttributeType; label: string }[] = [
  {
    value: 'boolean',
    label: 'Да/Нет'
  },
  {
    value: 'decimal',
    label: 'Десятичное'
  },
  {
    value: 'float',
    label: 'Десятичное'
  },
  {
    value: 'int',
    label: 'Целое'
  },
  {
    value: 'list',
    label: 'Список'
  },
  {
    value: 'string',
    label: 'Строка'
  }
]


type props = {
  value: ProductAttributeType
  onChange: (value: ProductAttributeType) => void
}

export default function ProductAttributeTypePicker ({ value, onChange }: props) {
  return (
    <SelectPicker
      data={productGroupTypes}
      value={value}
      onChange={onChange}
      cleanable={false}
      searchable={false}
    />
  )
}
